<template>
  <v-autocomplete
    item-value="code"
    :item-text="item => item.code + ' ' + item.description"
    :items="categories"
    v-model="contextValue"
    :label="$t('optima.category') + ' Optima'"
  />
</template>

<script>
export default {
  name: "OptimaCategorySelect",
  props: {
    value: { required: true },
    errorMessages: {
      required: false,
      default: null
    },
    rules: {
      required: false,
      default: null
    }
  },
  data: () => ({
    categories: []
  }),
  computed: {
    contextValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      }
    }
  },
  methods: {
    downloadCategories() {
      this.axios.get("optima/get-categories").then(response => {
        this.categories = response.data;
      });
    }
  },
  created() {
    this.downloadCategories();
  }
};
</script>

<style scoped></style>
